<template>
    <div class="bg-[#eeeeee] flex flex-col h-screen overflow-y-auto">
        <slot name="top">
            <TopBar class="mx-4" :title="title" transparent>
                <template #actions>
                    <slot name="actions" />
                </template>
            </TopBar>
        </slot>
        <div class="mx-8">
            <slot name="header"></slot>
        </div>
        <!-- overflow-y-hidden do not let tree view to scroll -->

        <card class="flex-1 overflow-y-auto mx-8 mt-4 mb-8">
            <slot></slot>
        </card>
    </div>
</template>

<script setup lang="ts">
import Card from '@/components/Card.vue';
import TopBar from '@/components/TopBar.vue';
defineProps<{
    title: string;
}>();
</script>
